import axios from 'axios';

export default class BaseApiService {
  axiosInstance;
  _baseURL;
  _userToken;

  constructor(config = {}) {
    this._baseURL = config.baseURL;
    const headers = config.headers || {};

    this.axiosInstance = axios.create({
      baseURL: this._baseURL,
      headers,
      paramsSerializer: {
        indexes: null,
      },
    });

    this.axiosInstance.interceptors.response.use(null, function (error) {
      //  TODO: implement better error handling
      //   if (error?.response?.status === 401) {
      //     return userStore.signout();
      //   }

      //   if (error?.response?.data?.errors?.length) {
      //     const errors = error.response.data.errors;
      //     errors.forEach((e) => trackError({ message: e }));
      //   } else {
      //     trackError(error);
      //   }

      return Promise.reject(error);
    });
  }

  get(url, params = {}) {
    return this.axiosInstance.get(url, { params });
  }

  post(url, data) {
    return this.axiosInstance.post(url, data);
  }

  put(url, data, config = {}) {
    return this.axiosInstance.put(url, data, config);
  }

  patch(url, data) {
    return this.axiosInstance.patch(url, data);
  }

  delete(url, config = {}) {
    return this.axiosInstance.delete(url, config);
  }
}
